<div class="stageContainer" >
    @if(!selectedCamerasList.length){
        <div class="defaultCameraContainer">
            <img class="noCamera" src="assets/library-icons/no-camera-selected.png">
        </div>
    }
    @else {
        <div 
        [ngClass]="selectedCamerasList.length <= 1? 'full-width': 'live-grid' "
          cdkDropList
          (cdkDropListDropped)="drop($event)"
        >
             @for (cam of selectedCamerasList; track cam.id; let i = $index) {
                <div 
                class="grid-item"
                cdkDrag
                [ngClass]="getGridClass(selectedCamerasList.length, i)"
                >
                <div class="video-container" #tile>
                    <div class="header-container">
                        <div class="header-text"> {{ cam.name }}</div>
                        <div class="control-centre">
                              <img class="action-buttons" (click)="downloadCurrentFrame(cam.id)" src="assets/library-icons/snapshot.svg">
                              <img class="action-large" src="assets/library-icons/fullscreen.svg" (click)="toggleFullscreen(tile)">
                        </div>
                    </div>
              <div class="body-container">
                  <video 
                    #videoPlayer
                    playsinline
                    crossorigin="anonymous"
                    class="videoPlayer"
                    (play)="cam.isPlaying = true"
                    (pause)="cam.isPlaying = false"
                    (timeupdate)="onVideoTimeUpdate(cam.id, $event)">
                </video> 
                </div>  
                  </div>
                </div>
            }
        </div>
    }
</div>
